import React, { FC } from "react";
import type { ContentfulImageLinkType } from "@/types";
import { Link } from "./link";
import { Image } from "./image";

export const ImageLink: FC<ContentfulImageLinkType> = ({
  file,
  aspect,
  link,
  showTitle,
}) => {
  return (
    <div className={`imageLink A${aspect}`}>
      {link ? (
        <Link noStyle href={link} className="imageLink--link">
          <Image
            src={file}
            alt={file.fields.title as string}
            className={`imageLink--image A${aspect}`}
          />
          {showTitle && file.fields.title && (
            <div className="container">
              <div className="imageLink--title">
                {file.fields.title as string}
              </div>
            </div>
          )}
        </Link>
      ) : (
        <div className="imageLink--link">
          <Image
            src={file}
            alt={file.fields.title as string}
            className={`imageLink--image A${aspect}`}
          />
          {showTitle && file.fields.title && (
            <div className="container">
              <div className="imageLink--title">
                {file.fields.title as string}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
